<template>
    <div>
        <div class="flex items-center mb-4 mt-3 justify-between">
            <div class="flex items-center">
                <i class="el-icon-arrow-left font-bold text-xl cursor-pointer" style="color: #999999" @click="goBack" />
                <p class="text-xl ml-2 font-bold" style="color: #ff8e3b">
                    {{ project }} - Results & Achievements
                </p>
            </div>
            <div>
                <el-button 
                    type="primary" 
                    size="small" 
                    icon="el-icon-download" 
                    @click="exportToCSV"
                    :disabled="isExporting">
                    {{ isExporting ? `Exporting... ${exportProgress}%` : 'Export CSV' }}
                </el-button>
            </div>
        </div>
        <!-- Export Progress Bar -->
        <el-progress 
            v-if="isExporting" 
            :percentage="exportProgress" 
            :text-inside="true"
            :stroke-width="20"
            style="margin: 10px 20px;">
        </el-progress>
        <!-- <p class="font-bold mt-3 text-lg" style="margin-left: 20px">{{project}} - Results & Achievements</p> -->
        <div style="padding: 20px;padding-top: 0px;">
            <el-table :data="dataList" style="font-size: 12px;box-sizing: border-box;" empty-text="No Data"
                :highlight-current-row="false" :highlight-selection-row="false"
                :header-cell-class-name="'custom-head-cell'" :cell-style="tableCellstyle"
                :row-class-name="'custom-row-bg'">
              
                <el-table-column type="index" label="#" width="60px" align="center">
                    <template slot-scope="scope">
                        {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="Student" label="Student Information" width="280px">
                    <template slot-scope="scope">
                        <div class="student-info">
                            <div class="student-info-name">
                                {{ scope.row.student.student_givenName_pinyin.charAt(0).toUpperCase() + scope.row.student.student_givenName_pinyin.slice(1) + ' ' +
                                    scope.row.student.student_lastName_pinyin.charAt(0).toUpperCase() + scope.row.student.student_lastName_pinyin.slice(1) }}
                            </div>
                            <div class="student-info-email">
                                {{ scope.row.student.student_email }}
                            </div>
                            <div class="student-info-grad">
                                Graduation: {{ scope.row.student.student_graduation }}
                            </div>
                            <div v-if="scope.row.sub_account_nameEN" class="student-info-grad">
                              {{ scope.row.sub_account_nameEN }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="application_team_code" label="Team" width="80px">
                    <template slot-scope="scope">
                        <div class="team-cell">
                            <el-tag 
                              v-if="scope.row.application_team_code" 
                              size="small" 
                              type="info">
                              {{ scope.row.application_team_code }}
                            </el-tag>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="Score">
                    <template slot-scope="scope">
                        <div class="score-container">
                            <div v-for="(score, index) in scope.row.scores" :key="index" class="score-item"
                                :class="{ 'score-item--cancelled': isScoreCancelled(score) }">
                                <span>{{ score.application_event + ' : ' + formatScoreResult(score) }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="Achievement">
                    <template slot-scope="scope">
                        <div class="achievements-container">
                            <span v-if="isResultCancelled(scope.row)" class="result-status result-status--cancelled">
                                Result Cancelled
                            </span>
                            <template v-else>
                                <div v-for="(award, index) in scope.row.awards" :key="index" class="achievement-item">
                                    <li class="no-word-break">{{ ''+award.award_lable }}</li>
                                </div>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="Operation" width="120px">
                    <template slot-scope="scope">
                      <!-- <div v-if=" (enableShowCert == true && scope.row.project_status != 'active' &&  scope.row.application_project == '2025WEC'  || scope.row.application_project == '2024AEO' || scope.row.application_project == '2025Envirothon_Asia' )&& (scope.row.application_status == '已缴费' || scope.row.application_status == '无需缴费')">
                            <el-button type="primary" size="small" @click="gotoAwardView(scope.row)">Certificate</el-button>
                        </div> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="totalCount > pageSize"
                @current-change="handlePageChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: center;">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {
  getAccountApplicationContacts,
    getStudentAppsByAccount,
    getStudentAppsByAccountWithNoResult,
    getStudentAppResult
} from '../../api/eae'
import{
  getUserId
} from '../../utils/store'
export default ({
    name: 'index',
    data() {
        return {
            enableShowCert: false,
            user_id:getUserId(),
            accountContacts:[],
            project: this.$route.query.project,
            project_id: this.$route.query.project_id,
            account_id: this.$route.query.account_id,
            dataList: [],
            currentPage: 1,
            pageSize: 30,
            totalCount: 0,
            exportProgress: 0,
            isExporting: false,
            allApplicationsData: []
        }
    },
    mounted() {
        this.fetechData()
        // this.requestAccountContacts()
    },
    methods: {

      // requestAccountContacts(){
      //   getAccountApplicationContacts(this.account_id,this.project_id).then((res)=>{
      //     const accountContacts = res.data.data
      //     accountContacts.forEach(contact_id => {
      //         if(this.user_id == contact_id){
      //            this.enableShowCert = true
      //         }
      //     });
      //   })
      // },

      gotoAwardView(row) {
            this.$router.push({
                path: '/award',
                query: {
                    id: row._id.$id
                }
            })
        },

        goBack() {
            this.$router.go(-1)
        },
        
        async exportToCSV() {
            if (this.isExporting) {
                this.$message.warning('Export already in progress')
                return
            }
            
            this.isExporting = true
            this.exportProgress = 0
            this.allApplicationsData = []
            
            const loading = this.$loading({
                lock: true,
                text: 'Fetching application list...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            try {
                // Step 1: Fetch all application IDs
                const appsResponse = await getStudentAppsByAccountWithNoResult(this.account_id, this.project_id)
                const applicationList = appsResponse.data.data || []
                
                if (applicationList.length === 0) {
                    this.$message.warning('No data to export')
                    loading.close()
                    this.isExporting = false
                    return
                }
                
                const totalApplications = applicationList.length
                loading.text = `Fetching detailed data: 0/${totalApplications}`
                
                // Step 2: Fetch detailed data for each application
                for (let i = 0; i < applicationList.length; i++) {
                    const app = applicationList[i]
                    try {
                        const applicationId = app._id && app._id.$id ? app._id.$id : app._id
                        const detailResponse = await getStudentAppResult(applicationId)
                        this.allApplicationsData.push(detailResponse.data.data)
                    } catch (err) {
                        console.error(`Error fetching details for application ${app._id}:`, err)
                        // Continue with partial data if one fails
                        this.allApplicationsData.push(app)
                    }
                    
                    // Update progress
                    this.exportProgress = Math.round(((i + 1) / totalApplications) * 100)
                    loading.text = `Fetching detailed data: ${i + 1}/${totalApplications} (${this.exportProgress}%)`
                }
                
                loading.close()
                
                // Step 3: Generate CSV with all data
                this.generateCSV(this.allApplicationsData)
                
            } catch (error) {
                console.error('Export error:', error)
                this.$message.error('Failed to export data')
                loading.close()
            } finally {
                this.isExporting = false
                this.exportProgress = 0
            }
        },
        
        generateCSV(dataList) {
            if (!dataList || dataList.length === 0) {
                this.$message.warning('No data to export')
                return
            }
            
            const csvHeaders = ['#', 'Name', 'Email', 'Graduation', 'Sub School', 'Team', 'Score', 'Achievement']
            
            const csvData = dataList.map((row, index) => {
                const firstName = row.student.student_givenName_pinyin.charAt(0).toUpperCase() + row.student.student_givenName_pinyin.slice(1)
                const lastName = row.student.student_lastName_pinyin.charAt(0).toUpperCase() + row.student.student_lastName_pinyin.slice(1)
                const fullName = firstName + ' ' + lastName
                
                const email = row.student.student_email || ''
                const graduation = row.student.student_graduation || ''
                const subSchool = row.sub_account_nameEN || ''
                const team = row.application_team_code || ''
                
                const scores = row.scores && row.scores.length > 0 
                    ? row.scores.map(score => `${score.application_event}: ${score.total_score}`).join('; ')
                    : ''
                
                const achievements = row.awards && row.awards.length > 0
                    ? row.awards.map(award => award.award_lable).join('; ')
                    : ''
                
                return [
                    index + 1,
                    fullName,
                    email,
                    graduation,
                    subSchool,
                    team,
                    scores,
                    achievements
                ]
            })
            
            const csvContent = [
                csvHeaders,
                ...csvData
            ].map(row => 
                row.map(cell => {
                    const cellStr = String(cell || '')
                    if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
                        return `"${cellStr.replace(/"/g, '""')}"`
                    }
                    return cellStr
                }).join(',')
            ).join('\n')
            
            const BOM = '\uFEFF'
            const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)
            
            const timestamp = new Date().toISOString().slice(0, 10)
            const filename = `${this.project}_Results_${timestamp}.csv`
            
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            
            this.$message.success(`CSV exported successfully - ${dataList.length} records`)
        },
        fetechData() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading", 
                background: "rgba(0, 0, 0, 0.7)",
            });
            const page = this.currentPage === 1 ? null : this.currentPage - 1;
            getStudentAppsByAccount(this.account_id, this.project_id, page).then((res) => {
                this.dataList = res.data.data
                this.totalCount = res.data.count || this.dataList.length
                loading.close()
            }).catch(err => {
                console.error('Error fetching data:', err)
                loading.close()
                
            })
            
        },
        handlePageChange(page) {
            this.currentPage = page
            this.fetechData()
        },
        isResultCancelled(row) {
            return Array.isArray(row.scores) && row.scores.some(score => this.isScoreCancelled(score))
        },
        isScoreCancelled(score) {
            return score && score.in_vain === true
        },
        formatScoreResult(score) {
            return this.isScoreCancelled(score) ? 'Result Cancelled' : score.total_score
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: Ubuntu-Bold;'
        },
    }
})
</script>
<style lang="scss" scoped>
/* Add this style definition */
.no-word-break {
  word-break: keep-all;     /* Prevent words from breaking at arbitrary points */
  white-space: normal;      /* Allow text to wrap to the next line */
  hyphens: none;            /* Disable automatic hyphenation */
  overflow-wrap: break-word; /* Allow long words to break if they overflow */
}

/deep/ .el-table .custom-row-bg {
    background: #FAE3E4;
}

/deep/ .el-table tbody .cell {
    font-family: Ubuntu-Light;
}

/deep/ .el-table .custom-head-cell {
    background: var(--c-primary);
    color: white;
    text-align: center;
    border: 1px solid white;
    box-sizing: border-box;
    font-family: Ubuntu-Bold;
}

.achievements-container {
  padding: 8px 12px;
  text-align: left;
}

.achievement-item {
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .no-word-break {
    padding-right: 8px;
  }
}

.result-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: Ubuntu-Bold;
  font-size: 12px;
  line-height: 1.4;
}

.result-status--cancelled {
  color: #9f2f2f;
  background: #f8d7da;
}

/deep/ .el-table .cell {
  padding: 12px;
}

/deep/ .el-table td.el-table__cell {
  padding: 8px 0;
}

/deep/ .el-table th.el-table__cell {
  padding: 12px 0;
}

/* Student information column specific styling */
.student-info {
  padding: 8px 0;
  
  &-name {
    font-weight: bold;
    margin-bottom: 4px;
  }
  
  &-email {
    font-size: 12px;
    color: #606266;
    margin-bottom: 2px;
  }
  
  &-grad {
    font-size: 12px;
    color: #909399;
  }
}

/* Team column styling */
.team-cell {
  padding: 8px 0;
}

/* Score column styling */
.score-container {
  padding: 12px;
  text-align: left;
}

.score-item {
  padding: 4px 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  span {
    white-space: normal;
    word-break: keep-all;
  }
}

.score-item--cancelled {
  color: #9f2f2f;
  background-color: #f8d7da;
  font-family: Ubuntu-Bold;
}

/* Additional cell padding enforcement */
/deep/ .el-table .el-table__cell:nth-child(3) .cell {
  padding: 0; /* Remove default cell padding for score column */
}

/* Achievement column styling */
.achievements-container {
  padding: 6px 0;
  text-align: left;
  
  .achievement-item {
    margin-bottom: 8px;
    display: flex;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    li.no-word-break {
      margin-left: 16px;
      padding-right: 8px;
    }
  }
}
</style>
